import Vue from 'vue'
import Router from 'vue-router'
import Home from '../../src/components/Home'
Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js